<template>
  <div>
    <v-row v-if="news" class="cursor-pointer">
      <v-col cols="12" md="4" class="d-flex align-center">
        <NuxtImg
          v-if="news.image_1"
          :src="news.image_1"
          :alt="news.image1_desc"
          class="image rounded-xl mr-8 w-100"
          format="webp"
          quality="80"
          loading="lazy"
        />
        <img
          v-else
          :src="PlaceholderImage"
          :alt="news.image1_desc"
          class="image rounded-xl mr-8 w-100"
          loading="lazy"
          decoding="async"
        />
      </v-col>

      <v-col>
        <div style="overflow: hidden">
          <v-chip
            class="bg-primary text-body-2 font-weight-medium"
            size="large"
          >
            {{ news.type_name }}
          </v-chip>
          <div class="text-h6 my-4 news-title">
            {{ isIndonesia() ? news.title_id : news.title_en }}
          </div>
          <div class="text-body-1 text-text-subdued">
            {{ formatDate(news.createdon, "date-en") }}
          </div>
        </div>
      </v-col>
    </v-row>

    <div v-else class="d-flex">
      <v-skeleton-loader type="image" />
      <div class="ml-6 flex-grow-1">
        <v-skeleton-loader type="chip" />
        <v-skeleton-loader type="heading, text@2" />
      </div>
    </div>
  </div>
</template>

<script>
import PlaceholderImage from "@/assets/images/home/news/news_Paylater.webp";

export default {
  name: "NewsCard",
  props: {
    news: Object,
  },
};
</script>

<style scoped>
::v-deep .v-skeleton-loader__image {
  height: 200px;
  width: 350px;
  z-index: 0;
}
.image {
  aspect-ratio: 1.8/1;
  object-fit: cover;
  object-position: center;
}
.news-title {
  overflow: hidden;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

@media only screen and (min-width: 960px) {
  .image {
    max-width: 300px;
  }
}
</style>
